var _defs, _rect, _path, _path2, _path3, _path4, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#45b29d;}.cls-2{fill:#304269;}.cls-3{fill:#eaae3a;}.cls-4{fill:#bd4932;}.cls-5{fill:#91bed4;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 512,
    rx: 256,
    ry: 256,
    width: 512
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.56,345.9s-40.81,33.64-40.42,62.45c.24,18,25.27,30.79,50,26L234,428.83Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M316.44,345.9s40.81,33.64,40.42,62.45c-.24,18-25.27,30.79-50,26L278,428.83Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M210.49,402.45c13.23,45.42,77.6,45.42,90.82,0,22.19-76.2,42.46-163.83,33.81-207.06-8.91-44.57-30-75.23-48.19-94.38a42.86,42.86,0,0,0-62.07,0c-18.18,19.15-39.27,49.81-48.19,94.38C168,238.62,188.3,326.25,210.49,402.45Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M255.9,75.54s-46.81,25.84-70.36,88.71h0s15.86,30.18,70.36,30.18c70.36,0,70.36-30.18,70.36-30.18C302.71,101.38,255.9,75.54,255.9,75.54Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 255.9,
    cy: 273.48,
    r: 50.86
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 255.9,
    cy: 273.48,
    r: 37.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.101314d357a08c82b93a3060042add60.svg";
export { ForwardRef as ReactComponent };